import { CornerPositionEnum } from '../enums/corner-position';
import { Point } from './point';

export class Box {
    private _topLeft: Point;
    private _topRight: Point;
    private _bottomLeft: Point;
    private _bottomRight: Point;

    constructor(topLeft: Point, bottomRight: Point) {
        this._topLeft = topLeft;
        this._bottomRight = bottomRight;
        this._topRight = new Point(bottomRight.x, topLeft.y);
        this._bottomLeft = new Point(topLeft.x, bottomRight.y);
    }

    public getCorner(cornerPosition: CornerPositionEnum): Point {
        switch (cornerPosition) {
            case CornerPositionEnum.topLeft:
                return this._topLeft;
            case CornerPositionEnum.topRight:
                return this._topRight;
            case CornerPositionEnum.bottomLeft:
                return this._bottomLeft;
            case CornerPositionEnum.bottomRight:
                return this._bottomRight;
            case CornerPositionEnum.box:
                return this._topLeft;
            default:
                return null;
        }
    }

    public setCorner(cornerPosition: CornerPositionEnum, value: Point) {
        switch (cornerPosition) {
            case CornerPositionEnum.topLeft:
                this.topLeft = value;
                break;
            case CornerPositionEnum.topRight:
                this.topRight = value;
                break;
            case CornerPositionEnum.bottomLeft:
                this.bottomLeft = value;
                break;
            case CornerPositionEnum.bottomRight:
                this.bottomRight = value;
                break;
            case CornerPositionEnum.box:
                this.topLeft = value;
                break;
            default:
                break;
        }
    }

    public addBorder(borderSize: number): void {
        this.topLeft = new Point(
            this._topLeft.x - borderSize,
            this._topLeft.y - borderSize
        );
        this.bottomRight = new Point(
            this._bottomRight.x + borderSize,
            this._bottomRight.y + borderSize
        );
    }

    public get width(): number {
        return this._topRight.x - this._topLeft.x;
    }

    public get height(): number {
        return this._bottomRight.y - this._topRight.y;
    }

    public get topLeft(): Point {
        return this._topLeft;
    }

    public set topLeft(value: Point) {
        this._topLeft = value;
        this._bottomLeft.x = value.x;
        this._topRight.y = value.y;
    }

    public get topRight(): Point {
        return this._topRight;
    }

    public set topRight(value: Point) {
        this._topRight = value;
        this._bottomRight.x = value.x;
        this._topLeft.y = value.y;
    }

    public get bottomLeft(): Point {
        return this._bottomLeft;
    }

    public set bottomLeft(value: Point) {
        this._bottomLeft = value;
        this._bottomRight.y = value.y;
        this._topLeft.x = value.x;
    }

    public get bottomRight(): Point {
        return this._bottomRight;
    }

    public set bottomRight(value: Point) {
        this._bottomRight = value;
        this._bottomLeft.y = value.y;
        this._topRight.x = value.x;
    }
}
